class ShadowDOMUtils {

    static injectStylesheet(shadowHost, styles) {
        if (!shadowHost || !shadowHost.shadowRoot) {
            console.error("The provided element is not a shadow host or does not have a shadow root.");
            return;
        }

        const styleElement = document.createElement('style');
        styleElement.textContent = styles;

        // Prepend the style element in the shadow root
        shadowHost.shadowRoot.prepend(styleElement);

        console.log("Styles added to shadow root:", styles);
    }

    static waitForShadowHostAndAddStyles(selector, styles) {
        // Create a MutationObserver to watch for changes in the document body
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const shadowHost = document.querySelector(selector);
                    if (shadowHost && shadowHost.shadowRoot) {
                        this.injectStylesheet(shadowHost, styles);
                        observer.disconnect(); // Stop observing after adding styles
                        return; // Exit once styles are added
                    }
                }
            }
        });

        // Start observing the document body for additions or removals of child elements
        observer.observe(document.body, { childList: true, subtree: true });

        // Optional: Check initially if the shadow host is already present
        const existingHost = document.querySelector(selector);
        if (existingHost && existingHost.shadowRoot) {
            this.addStylesToShadowDom(existingHost, styles);
            observer.disconnect(); // Stop observing if already found
        }
    }

    static waitForElementByQuerySelector(selector, callback) {
        const checkExist = setInterval(() => {
            // Get the shadow host element
            const shadowHost = document.getElementById('app-embed'); // Adjust this to your shadow host ID or selector
            if (shadowHost && shadowHost.shadowRoot) {
                // Query the element inside the shadow DOM
                const element = shadowHost.shadowRoot.querySelector(selector);
                if (element) {
                    callback(element);
                    clearInterval(checkExist);
                }
            }
        }, 100);
    }
}